import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import MessageProvider from './components/common/MessageProvider'
import AntdConfigProvider from './components/common/AntdConfigProvider'
import './styles/global.less'
import './styles/dropdown-theme.less'
import './styles/arcgis-popup-override.css'
import '@arcgis/core/assets/esri/themes/light/main.css'
// 初始化 i18n
import './locales'

// TanStack Query 一直在依赖与技术栈清单里，但此前没人真正用起来，也就没设过 Provider。
// 决策树页面（/model/tree）是第一个使用者：它要在拖拽挂载后按 key 失效并重取整棵树，
// 手写 useState/useEffect 管这套缓存并不划算。
// 其余页面仍走各自的 useState/useEffect 取数，不受影响 —— 这里只是把 Provider 补齐。
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 失败重试交由各查询自行决定：多数接口失败就是失败，闷头重试只会让用户多等
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AntdConfigProvider>
        <MessageProvider>
          <App />
        </MessageProvider>
      </AntdConfigProvider>
    </QueryClientProvider>
  </BrowserRouter>
)
